import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../AuthProvider/AuthProvider';
import { SignInRoute } from '@/models';
import { useAuthProvider } from '@/store';

const BASE_URL = window.location.origin;

export const AccessDenied = () => {
  const navigate = useNavigate();
  const { fallback } = useAuth();

  const authProvider = useAuthProvider();

  useEffect(() => {
    if (authProvider) {
      const { logoutRedirectUri, hasLoginPage } = authProvider;

      history.pushState(null, '', `${BASE_URL}/${SignInRoute.AccessDenied}`);

      const url = hasLoginPage ? logoutRedirectUri : `/${SignInRoute.AccessDenied}`;

      navigate(url, { replace: true, state: { isModalOpened: true } });
    }
  }, [navigate, authProvider]);

  return fallback;
};
